<template>
    <Modal :open="open" :show-close-icon="true" @close="closeModal" :is-card="true" :narrow="false">
        <template v-if="customerDetailsSubmitted == false">
            <h2 class="save-configurator-modal__title">Save your configuration</h2>
            <p class="p--center">Please fill in your details below to save your configuration.</p>

            <form @submit.prevent="submit" ref="form">
                <div class="form-grid form-grid--xs-1-column">
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <customer-title />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <first-name />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <last-name />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <email />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <telephone :input-nullable="false" />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <customer-location />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <dealer :filter-new="true" />
                    </div>
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <privacy></privacy>
                    </div>
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width" style="justify-self: center;">
                        <button type="submit" class="btn btn--primary btn--min-width">Continue</button>
                    </div>
                </div>
            </form>
        </template>
        <template v-else>
            <h2 class="save-configurator-modal__title">Thank you for saving your configuration</h2>

            <ImageGallery :is-carousel="false" :small-image="true"/>

            <div class="body">
                <p class="p--center">We have sent you a confirmation email with your choices so far and links to allow you to continue
                    your configuration in the future.</p>

                <p class="p--center">Please use the links below to learn more about the {{ model.model_title }} or to book a test
                    drive.</p>
            </div>

            <div class="save-configurator-modal__footer">
                <a :href="testDriveUrl" class="btn btn--primary btn--long btn--full-width-xs">Book a Test Drive</a>

                <a :href="showroomUrl" class="btn btn--primary-inverted btn--long btn--full-width-xs">Discover More</a>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "../../core/components/Modal.vue";
import CustomerTitle from "../../core/components/Forms/Title.vue";
import FirstName from "../../core/components/Forms/FirstName.vue";
import LastName from "../../core/components/Forms/LastName.vue";
import Email from "../../core/components/Forms/Email.vue";
import Telephone from "../../core/components/Forms/Telephone.vue";
import Privacy from "../../core/components/Forms/Privacy.vue";
import CustomerLocation from "../../core/components/Forms/CustomerLocation.vue";
import Dealer from "../../core/components/Forms/Dealer.vue";
import { mapState } from "vuex";
import ContactFormValidator from "../../validation/ContactFormValidator";
import CustomerLocationHandler from "../../modules/CustomerLocationHandler";
import { customEvent, generateLeadEvent } from '../../modules/tracking/AnalyticsEvents';

export default {
    components: {
        Modal,
        CustomerTitle,
        FirstName,
        LastName,
        Email,
        Telephone,
        Privacy,
        CustomerLocation,
        Dealer,
    },
    data() {
        return {
            validator: null,
            customerLocationHandler: null,
            open: false,
        };
    },
    methods: {
        async submit() {
            if (!await this.validator.isValid()) {
                return;
            }

            reCaptchaProtect(() => {
                this.$store
                    .dispatch("syncDatabase", this.$route.query)
                    .then(() => {
                        const formData = new FormData(this.$refs.form);
                        formData.append("configuratorId", this.configuratorId);

                        this.validator.preventInput();

                        axios
                            .post('/api/configurator/save-configuration', formData)
                            .then(() => {
                                this.validator.allowInput();
                                customEvent("New Car - Configurator", "Save Configuration", "Complete");
                                generateLeadEvent('new_configuration_saved');
                                this.$store.commit("setCustomerDetailsSubmitted", true);
                            })
                            .catch(error => {
                                console.error(error);
                                this.validator.errorResponse(error);
                            });
                    })
                    .catch(error => {
                        console.error(error);
                        this.validator.errorResponse(error);
                    });
            });
        },

        openModal(customAnalyticsEvent = null) {
            this.open = true;
            if (customAnalyticsEvent) {
                customEvent(customAnalyticsEvent);
            } else {
                customEvent("New Car - Configurator", "Save Configuration", "Opened");
            }
        },

        closeModal() {
            this.open = false;
        }
    },
    computed: {
        ...mapState(['brand', 'configuratorId', 'model', 'customerDetailsSubmitted']),
        testDriveUrl() {
            return `/${this.model.brand}/book-a-test-drive/${this.model.url_model}`;
        },
        showroomUrl() {
            return `/${this.model.brand}/new/${this.model.url_model}`;
        }
    },
    mounted() {
        this.validator = new ContactFormValidator({
            vueForm: true,
            redesign: true,
            element: this.$refs["form"],
        });
        this.customerLocationHandler = new CustomerLocationHandler({
            element: this.$refs["form"],
            additionalLocationFilterFunction: dealer => dealer.brand == this.brand
        });
    },
};
</script>

<style lang="scss">
.save-configurator-modal {
    &__title {
        text-align: center;
        color: #192a44;
    }
    &__footer {
        display: grid;
        grid-template-columns: 1fr;
        row-gap: 15px;
        margin: 0 auto;
        @media (min-width: 768px) {
            grid-template-columns: 1fr 1fr;
            column-gap: 15px;
        }
    }
}

</style>


// WEBPACK FOOTER //
// resources/assets/js/configurator/components/SaveConfigurationModal.vue